export default __webpack_public_path__ + "static/media/p11.b0cb1215.jpeg";